/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_cognito_identity_pool_id": "us-east-1:06847e58-b8ac-4088-b7d6-0cbf66dcb810",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_Ebqfk2cuF",
    "aws_user_pools_web_client_id": "4d32b74doh23cvh74nldcuov4",
    "oauth": {}
};


export default awsmobile;
